/*
 * @Author: zn
 * @Date: 2022-09-28 10:40:05
 * @LastEditors: zn
 * @LastEditTime: 2022-10-08 11:35:25
 * @FilePath: \huangshi_door\src\api\noApply.js
 */
import axios, {
  _get,
  _post,
  _delete,
  _put,
  _patch,
  _postParams,
} from "./index";
// 获取所有问题
export const pageList = (data) => {
  const req = {
    data,
    url: "zstapi/data/adminEnjoyWithoutApplication/pageList",
  };

  return _get(req);
};
// 首页统计
export const getCountAll = (data) => {
  const req = {
    data,
    url: "zstapi/data/policy/getCountAll",
  };

  return _get(req);
};
// 无申请兑现详情
export const getById = (data) => {
  const req = {
    data,
    url: "zstapi/data/adminEnjoyWithoutApplication/getById",
  };

  return _get(req);
};

// 无申请兑现申請
export const fulfill = (data) => {
  const req = {
    method: "post",
    data,
    url: "zstapi/data/adminEnjoyWithoutUserCode/fulfill",
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axios(req);
};
// 企业信息查询
export const getCorporateInfo = (data) => {
  const req = {
    data,
    url: "zstapi/user/company/getCorporateInfo",
  };

  return _get(req);
};
// 我的
export const myFulfillPageList = (data) => {
  const req = {
    data,
    url: "zstapi/data/adminEnjoyWithoutUserCode/myFulfillPageList",
  };

  return _postParams(req);
};
// 我的
export const myProjectPageList = (data) => {
  const req = {
    data,
    url: "zstapi/member/lsMyProject/pageList",
  };

  return _get(req);
};
// 申报项目列表
export const declareProjectPageList = (data) => {
  const req = {
    data,
    url: "zstapi/data/userDeclareItem/pageList",
  };

  return _get(req);
};
// 滚动查询
export const dataPageList = (data) => {
  const req = {
    data,
    url: "zstapi/member/lsMyProject/getGdList",
  };

  return _get(req);
};
// 无申请兑现列表滚动查询
export const cashScrollList = (data) => {
  const req = {
    data,
    url: "zstapi/data/adminEnjoyWithoutUserCode/getGdList",
  };

  return _get(req);
};
// 获取银行信息
export const getBankAccount = (data) => {
  const req = {
    data,
    url: "zstapi/data/adminEnjoyWithoutUserCode/getBankAccount",
  };

  return _get(req);
};
